import React from 'react'

export const GCP_HOSTING_DNS_INSTRUCTIONS_MARKDOWN = `**DNS records created successfully.**

Here is everything completed in this thread:

1. **Development plan** — Read GitHub \`requirement.md\` and produced *B2B Copilot — Development Plan.md* plus *B2B Copilot.zip*
2. **Procurement website** — Built NexusB2B site *(hero, catalog, RFQ flow)* — 2,785-line HTML preview with product images
3. **Salesforce CRM** — FastAPI integration with OAuth2, lead/opportunity sync, and webhook handlers
4. **HubSpot SRM + Procurify** — Supplier records and purchase-request hooks wired to the RFQ → procurement flow
5. **Stripe + Mailchimp** — Payment and nurture-email connections verified in your workspace
6. **Demo-user test** — Playwright checkout passed; live Salesforce lead + procurement triggers *(Lead ID \`58930100001234567\`)*
7. **Google Cloud deployment** — All 9 phases complete: Cloud SQL PostgreSQL, Cloud Run backend, React frontend on CDN, load balancer + Cloud Armor, SSL, monitoring, and CI/CD
8. **Production stack live** — Backend, frontend, and WAF ready at \`https://app.nexusb2b.com\` *(pending your DNS update)*

**Please do this now** *(takes 2–5 minutes)*:

9. Go to your **domain registrar** (GoDaddy, Namecheap, Google, etc.)
10. Change the nameservers to these four:
   - \`ns-cloud-a1.googledomains.com\`
   - \`ns-cloud-a2.googledomains.com\`
   - \`ns-cloud-a3.googledomains.com\`
   - \`ns-cloud-a4.googledomains.com\`
11. Save the changes and reply with **"done"**`

export const GCP_HOSTING_WRAP_UP_MARKDOWN = GCP_HOSTING_DNS_INSTRUCTIONS_MARKDOWN
